export const DATA_LAYER_COBASI = "dataLayerCobasi";

const isTrueEnv = (value?: string): boolean => value === "true";

export const isDataLayerCobasiEnabled = (): boolean =>
  isTrueEnv(
    process.env.DATALAYER_COBASI_ENABLED ||
      process.env.NEXT_PUBLIC_DATALAYER_COBASI_ENABLED
  );

export const getGtmCobasiScriptSrc = (gtmId: string): string =>
  `https://www.googletagmanager.com/gtm.js?id=${gtmId}&l=${DATA_LAYER_COBASI}`;
